import React from 'react';

import { ProfileView } from '../components/ProfileView/ProfileView';
import { TalentDataProvider } from '../providers/TalentDataProvider';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type TalentProfilePageProps = {
  name?: string;
};

export const TalentProfilePage = ({
  name = 'TALENT_PROFILE_PAGE',
}: TalentProfilePageProps) => {
  useDocumentTitle('Talent Profile');
  return (
    <div data-test={name}>
      <TalentDataProvider>
        <ProfileView />
      </TalentDataProvider>
    </div>
  );
};
